export default "/institutions/schwab.svg";